/**
 * @generated SignedSource<<898721ad69258e51521da4d5a6f7681b>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v1 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "schedulable": true
                    }
                },
                {
                    "kind": "Literal",
                    "name": "order",
                    "value": [
                        {
                            "isWork": "DESC"
                        },
                        {
                            "isAbsence": "DESC"
                        },
                        {
                            "name": "ASC"
                        }
                    ]
                },
                {
                    "kind": "Literal",
                    "name": "where",
                    "value": {
                        "isWork": {
                            "eq": true
                        }
                    }
                }
            ],
            "concreteType": "EventConnection",
            "kind": "LinkedField",
            "name": "events",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "EventEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Event",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "name",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isAbsence",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "AssignmentType",
                                    "kind": "LinkedField",
                                    "name": "assignmentTypes",
                                    "plural": true,
                                    "selections": [
                                        (v0 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "title",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": "events(filter:{\"schedulable\":true},order:[{\"isWork\":\"DESC\"},{\"isAbsence\":\"DESC\"},{\"name\":\"ASC\"}],where:{\"isWork\":{\"eq\":true}})"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "EditScheduleShiftEventQuery",
            "selections": (v1 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "EditScheduleShiftEventQuery",
            "selections": (v1 /*: any*/)
        },
        "params": {
            "cacheID": "55db7998fd4b1178237b81a6567d3943",
            "id": null,
            "metadata": {},
            "name": "EditScheduleShiftEventQuery",
            "operationKind": "query",
            "text": "query EditScheduleShiftEventQuery {\n  events(where: {isWork: {eq: true}}, filter: {schedulable: true}, order: [{isWork: DESC}, {isAbsence: DESC}, {name: ASC}]) {\n    edges {\n      node {\n        id\n        name\n        isAbsence\n        assignmentTypes {\n          id\n          title\n        }\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "6725787676d87a72aa4ab2a027eed015";
export default node;
